import { Bounds, useBounds } from "@react-three/drei"
import { useThree } from "@react-three/fiber"
import { useContext, useEffect, useRef } from "react"

import AppContext from "../../hooks/AppConext"
import { useCameraMouseRotation } from "../../hooks/useCameraMouseRotation"

const ResizeHandler = () => {
  const api = useBounds()
  const handleResize = api.fit
  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
}

export const SmartBounds = ({ children }) => {
  const { selected, setHeight } = useContext(AppContext)
  const data = useRef()
  const { camera } = useThree()
  const handleFit = ({ size }) => {
    if (!selected) {
      setHeight(size.y)
    }
    const angle = Math.atan2(camera.position.x, camera.position.z)
    const radius = Math.sqrt(camera.position.x ** 2 + camera.position.z ** 2)
    data.current = {
      angle,
      radius,
    }
  }

  useCameraMouseRotation(data)

  return (
    <Bounds damping={false} onFit={handleFit} fit margin={1}>
      <ResizeHandler />
      {children}
    </Bounds>
  )
}
